import React from 'react';
import { Typography } from '@mui/material';

export const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    sx={{
      fontSize: 12,
      color: 'grey.600',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    }}
  >
    {children}
  </Typography>
);
